import { getApi } from "../services/axios";
import APIs from ".";

export async function fetchMeetingRecordings(filters: {
  from?: string;
  to?: string;
  clientId: string;
  ambassadorId?: string;
}) {
  const { from = "", to = "", clientId, ambassadorId = "" } = filters;
  return getApi(
    APIs.CLIENTS.GET_MEETING_RECORDINGS({
      from,
      to,
      clientId,
      ambassadorId,
    }),
    { validateUser: true }
  );
}

export async function fetchInvitationRecordingParticipants(params: {
  clientId: string;
} | {
  ambassadorId: string;
}) {
  const url = APIs.CLIENTS.GET_RECORDING_PARTICIPANTS(
    "clientId" in params
      ? { clientId: params.clientId }
      : { ambassadorId: params.ambassadorId }
  );
  return getApi(url, { validateUser: true });
}
